module.exports = __webpack_public_path__ + "img/17.2e943749.webp";